import React, { useEffect, useState } from 'react';
import { getPublishedArticles } from '../firebase/firestore';
import './BreakingNewsTicker.css';

export default function BreakingNewsTicker() {
  const [headlines, setHeadlines] = useState([]);

  useEffect(() => {
    getPublishedArticles(10).then(articles => {
      setHeadlines(articles.map(a => a.title));
    });
  }, []);

  if (!headlines.length) return null;

  return (
    <div className="ticker-wrap">
      <div className="ticker-label">🔴 BREAKING</div>
      <div className="ticker-content">
        <div className="ticker-items">
          {[...headlines, ...headlines].map((h, i) => (
            <span key={i} className="ticker-item">
              {h} <span className="ticker-sep">◆</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
